import React from 'react';
import { useToggle } from 'usehooks-ts';
import { useParams } from 'react-router-dom';

import {
  DownloadReportResourceAsync,
  GetEventReportResourceAsync
} from '../../../../services/event-reports';
import { Downloadble } from '../../downloadable';

export const DownloadableMedia: React.FC<{
  amount: number;
  fileName: string;
  type: 'image' | 'video';
}> = ({ type, fileName, amount }) => {
  const { eventId, detailId } = useParams();

  const [isLoading, toggleIsLoading] = useToggle(false);

  const onClick = async () => {
    toggleIsLoading();
    try {
      const response = await GetEventReportResourceAsync(
        eventId ?? '',
        detailId ?? '',
        ''
      );
      const filteredMedia = response.data.filter(
        (res: any) => res.type === type
      );

      await DownloadReportResourceAsync(
        parseInt(eventId!),
        `${fileName}-${type === 'image' ? 'Photos' : 'Videos'}`,
        filteredMedia.map((m: any) => m.id)
      );
    } catch (err) {
      console.error(err);
    } finally {
      toggleIsLoading();
    }
  };

  return (
    <Downloadble
      disabled={isLoading}
      downloadText={isLoading ? 'Downloading' : 'Download'}
      onClick={onClick}
      text={type === 'image' ? 'Photos' : 'Videos'}
      icon={type === 'video' ? 'animated_images' : 'live_tv'}
      amount={amount}
      bgColor={type === 'image' ? '#14BF8B' : '#D42733'}
    />
  );
};
